export interface AvisoPrivacidadSection {
  title: string;
  paragraphs: string[];
}

export const AVISO_PRIVACIDAD = {
  title: 'Aviso de privacidad integral',
  responsible: 'EAP Consulting Group',
  version: '2026-10-12',
  lastUpdatedLabel: '12 de octubre de 2026',
  intro:
    'EAP Consulting Group (en adelante, “EAP” o el “Responsable”) pone a disposición este Aviso de Privacidad Integral conforme a la Ley Federal de Protección de Datos Personales en Posesión de los Particulares vigente. Se refiere a la recepción, gestión y canalización de solicitudes de asistencia psicológica y emocional, legal, financiera y nutricional para personas beneficiarias de programas contratados por empresas.',
  sections: [
    {
      title: '1. Identidad y contacto',
      paragraphs: [
        'Responsable: EAP Consulting Group.',
        'Domicilio: Nueva York 234, PB, colonia Nápoles, alcaldía Benito Juárez, C.P. 03810, Ciudad de México.',
        'Teléfono: 55 9661 6637. Correo de contacto, privacidad y derechos ARCO: contacto@eapconsulting.mx.'
      ]
    },
    {
      title: '2. Personas a quienes se dirige',
      paragraphs: [
        'Este aviso aplica a trabajadores beneficiarios, familiares elegibles y otras personas que soliciten o reciban los servicios de EAP. La empresa empleadora contrata la cobertura, pero la información individual de las consultas no se entrega al empleador como parte de los reportes ordinarios.'
      ]
    },
    {
      title: '3. Datos personales tratados',
      paragraphs: [
        'Identificación y contacto: nombre cuando se proporcione, edad, teléfono, correo y datos necesarios para confirmar elegibilidad. Datos laborales: empresa de adscripción y, cuando sea necesario, puesto o antigüedad. Datos de la solicitud: tipo de servicio, fecha, motivo general, información mínima para la canalización y seguimiento.',
        'Datos sensibles: cuando la persona los comunique, información sobre salud física o mental, situación emocional, circunstancias familiares íntimas u otra información que afecte su esfera más íntima. EAP procura no realizar entrevistas clínicas profundas durante el Intake. Una atención puede ser anónima frente al empleador sin que necesariamente sea anónima para EAP.'
      ]
    },
    {
      title: '4. Obtención de datos',
      paragraphs: [
        'Los datos se obtienen principalmente por llamada telefónica y, cuando corresponda, por medios de contacto y formularios vinculados a la atención. La persona puede comunicar espontáneamente información sensible durante una llamada de orientación o crisis.'
      ]
    },
    {
      title: '5. Finalidades necesarias',
      paragraphs: [
        'Verificar elegibilidad; atender solicitudes; proporcionar orientación inicial y contención no clínica; registrar el Intake mínimo; identificar situaciones que requieren canalización urgente; contactar y asignar profesionales; coordinar citas; dar seguimiento administrativo; proteger la seguridad de usuarios y personal; gestionar quejas, solicitudes ARCO y obligaciones legales.',
        'Los reportes a empresas contratantes son estadísticos y agregados, sin nombres ni detalles clínicos. Se aplican medidas para evitar reidentificación, especialmente en grupos pequeños. No se usan los datos de consulta para publicidad o prospección comercial.'
      ]
    },
    {
      title: '6. Datos sensibles y consentimiento',
      paragraphs: [
        'Cuando el tratamiento de datos sensibles requiera consentimiento, EAP solicitará consentimiento expreso y por escrito mediante firma autógrafa, firma electrónica o mecanismo de autenticación jurídicamente válido antes del tratamiento correspondiente. Una aceptación verbal o una grabación no se considerarán automáticamente sustitutos del consentimiento escrito.',
        'Cuando se actualice una excepción legal, EAP podrá realizar el tratamiento estrictamente necesario sin recabar ese consentimiento, documentando la justificación. En situaciones de emergencia con riesgo potencial de daño, priorizará la contención y canalización indispensable. La sola existencia de una relación comercial con el empleador no se considera autorización general para tratar datos sensibles del trabajador.'
      ]
    },
    {
      title: '7. Profesionales y terceros',
      paragraphs: [
        'Para canalizar y prestar el servicio, EAP puede compartir con profesionales contratados únicamente la información necesaria para la atención. Los terapeutas son profesionales independientes sujetos a contratos y obligaciones de confidencialidad. La calificación de cada profesional como encargado o responsable independiente depende de sus funciones reales y de los acuerdos aplicables.',
        'Los expedientes clínicos que el profesional deba conservar bajo sus obligaciones profesionales se gestionan conforme a su propio marco aplicable; EAP no solicita ordinariamente notas clínicas detalladas para reportarlas a empleadores. Cuando corresponda una transferencia que requiera consentimiento, éste se recabará previamente, salvo excepción legal.'
      ]
    },
    {
      title: '8. Proveedores y tratamiento internacional',
      paragraphs: [
        'EAP puede utilizar proveedores de telefonía, mensajería, alojamiento, correo, almacenamiento, respaldo y soporte tecnológico que traten información por su cuenta bajo obligaciones de confidencialidad y seguridad. Algunos servicios pueden operar desde otros países. EAP aplicará los requisitos legales y contractuales correspondientes, distinguiendo remisiones a encargados de transferencias a responsables independientes.'
      ]
    },
    {
      title: '9. Grabación de llamadas',
      paragraphs: [
        'Las llamadas podrán ser grabadas únicamente cuando EAP tenga habilitado ese servicio y haya informado oportunamente sobre su existencia, finalidad y tratamiento. Cuando no se graben, el registro de atención se limitará a la información necesaria. Las grabaciones, si existen, estarán sujetas a controles de acceso y periodos de conservación justificados.'
      ]
    },
    {
      title: '10. Seguridad y confidencialidad',
      paragraphs: [
        'EAP adopta medidas administrativas, físicas y técnicas proporcionales a la sensibilidad de los datos: acceso restringido, deberes de confidencialidad, protección de comunicaciones, respaldos y medidas para prevenir accesos o divulgaciones no autorizadas. Los empleadores no reciben información individual de la consulta como parte de los informes ordinarios.'
      ]
    },
    {
      title: '11. Derechos ARCO',
      paragraphs: [
        'La persona titular puede solicitar acceso, rectificación, cancelación u oposición escribiendo a contacto@eapconsulting.mx. La solicitud debe indicar nombre o elementos para identificar el registro, derecho que desea ejercer, descripción clara de la petición y un medio de respuesta; EAP podrá solicitar elementos razonables para acreditar identidad o representación. EAP responderá conforme a los plazos legales aplicables.'
      ]
    },
    {
      title: '12. Limitación y revocación',
      paragraphs: [
        'Para limitar uso o divulgación de datos, o solicitar revocación del consentimiento cuando proceda, escriba a contacto@eapconsulting.mx. La revocación no tiene efectos retroactivos y no impedirá tratamientos que deban mantenerse por obligación legal o por otra base legal aplicable.'
      ]
    },
    {
      title: '13. Menores y familiares',
      paragraphs: [
        'Los familiares adultos ejercen sus derechos y proporcionan sus propios consentimientos. Cuando el servicio involucre menores, se verificará la representación y autorización de quien legalmente corresponda, considerando las reglas aplicables y las necesidades de atención urgente.'
      ]
    },
    {
      title: '14. Conservación y supresión',
      paragraphs: [
        'Los datos se conservarán únicamente por el tiempo necesario para las finalidades indicadas y para atender obligaciones legales o contractuales aplicables. Concluidos los plazos pertinentes se realizará el bloqueo y la supresión que proceda. Los expedientes clínicos bajo responsabilidad de profesionales pueden estar sujetos a plazos específicos.'
      ]
    },
    {
      title: '15. Cookies y plataformas',
      paragraphs: [
        'Cuando se utilicen sitios o plataformas con cookies u otras tecnologías, se informará sobre su finalidad y las opciones disponibles para gestionarlas, conforme al funcionamiento real de dichos medios.'
      ]
    },
    {
      title: '16. Modificaciones',
      paragraphs: [
        'Los cambios al aviso se comunicarán mediante el sitio oficial de EAP Consulting Group o el medio por el cual se preste el servicio. Cuando una nueva finalidad o transferencia requiera consentimiento, éste se solicitará antes del tratamiento correspondiente.'
      ]
    },
    {
      title: '17. Información adicional',
      paragraphs: [
        'Para dudas sobre privacidad, tratamiento de datos y solicitudes relacionadas, comuníquese al teléfono 55 9661 6637 o al correo contacto@eapconsulting.mx.'
      ]
    }
  ] satisfies AvisoPrivacidadSection[]
};

export const avisoPrivacidadPlainText = (): string => {
  const blocks = [
    AVISO_PRIVACIDAD.title.toUpperCase(),
    `${AVISO_PRIVACIDAD.responsible} | ${AVISO_PRIVACIDAD.lastUpdatedLabel}`,
    AVISO_PRIVACIDAD.intro,
    ...AVISO_PRIVACIDAD.sections.flatMap((section) => [section.title, ...section.paragraphs])
  ];
  return blocks.join('\n\n');
};
